import React from "react"
import Link from 'gatsby-link'

export default function HomeLogo (props){
    return(
        <Link to="/portfolio/" className="home">
        GORKA MUÑOZ
        </Link>
    );
}



// WEBPACK FOOTER //
// ./src/components/Linking/homeLogo.js